import { render, staticRenderFns } from "./KnowledgeBaseExplorerPath.vue?vue&type=template&id=2682a3d6&scoped=true&lang=pug&"
import script from "./KnowledgeBaseExplorerPath.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseExplorerPath.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseExplorerPath.vue?vue&type=style&index=0&id=2682a3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682a3d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
